import React, { Component } from "react"
import { Button } from "semantic-ui-react"
import { Icon } from "semantic-ui-react"
import { Icon as IconKit } from "react-icons-kit"
import "./BouttonEntete.css"
class BouttonEntete extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Button
        onClick={this.props.onClick}
        icon={
          this.props.iconName ? (
            <Icon class="btnEnteteIcon" name={this.props.iconName} />
          ) : (
            <IconKit
              className="btnEnteteIcon"
              size={17}
              icon={this.props.icon}
            />
          )
        }
        id={this.props.style}
        className="btnEnteteInner"
        content={<p className="btnEnteteText">{this.props.text}</p>}
      />
    )
  }
}

export default BouttonEntete



// WEBPACK FOOTER //
// ./src/components/Pro/Entete/BouttonEntete.js